var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var BuildEvent = /** @class */ (function (_super) {
    __extends(BuildEvent, _super);
    function BuildEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * List all deploy events
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-event/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildEvent.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all deploy events
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-event/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildEvent.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/build-events',
        });
    };
    /**
     * Retrieve a deploy event
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-event/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildEvent.prototype.find = function (buildEventId) {
        return this.rawFind(Utils.toId(buildEventId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a deploy event
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/build-event/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    BuildEvent.prototype.rawFind = function (buildEventId) {
        return this.client.request({
            method: 'GET',
            url: "/build-events/".concat(buildEventId),
        });
    };
    BuildEvent.TYPE = 'build_event';
    return BuildEvent;
}(BaseResource));
export default BuildEvent;
//# sourceMappingURL=BuildEvent.js.map